import { createSlice } from "@reduxjs/toolkit";
import Cookies from 'js-cookie'

const initialState = {
    token: Cookies.get("token") ? JSON.parse(Cookies.get("token")) : null
}

const tokenSlice = createSlice({
    name: "tokenSlice",
    initialState,
    reducers: {
        setToken: (state, action) => {
            state.token = action.payload;
            Cookies.set("token", JSON.stringify(action.payload), {
                expires: 1 / 12
            });
            return state;
        },
        removeToken: (state, action) => {
            state.token = null;
            Cookies.remove("token");
            return state;
        }
    }

});

export const { setToken, removeToken } = tokenSlice.actions;
export default tokenSlice;